<div class="ya-bottomsheet-container ya-typography">
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-handy-notification"></div>
    </div>
    <h2 langkey="phNotification_Dialog_Title"></h2>
    <p>
      <span langkey="phNotification_Dialog_Content"></span>
    </p>
    <ng-container *ngIf="dialogData.digiPagerText">
      <p>{{dialogData.digiPagerText}}</p>
    </ng-container>
    <div class="ya-button-container">
      <button mat-flat-button (click)="setNotification()">
        <span langkey="phNotification_Dialog_AcceptButton"></span>
      </button>
    </div>
    <p>
      <span langkey="phNotification_Dialog_Annotation"></span>
    </p>
    <div class="divider"></div>
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phNotification_Dialog_DiscardTitle">
    </h2>
    <p>
      <span
        [langkey]=" dialogData.isInHouseGroupOrder?'phNotification_Dialog_DiscardContent_IHGroup':'phNotification_Dialog_DiscardContent'"></span>
    </p>
    <div class="ya-button-container">
      <button mat-flat-button class="ghostbutton" (click)="discardToMenuGroup()">
        <span
          [langkey]=" dialogData.isInHouseGroupOrder?'phNotification_Dialog_DiscardButton_IHGroup': 'phNotification_Dialog_DiscardButton'"></span>
      </button>
    </div>
  </div>
</div>